import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { Translation } from '@/hoslog-intl';
import { UserPenIcon } from '@/icons/user-pen-icon';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/store-information/basic-stores/host-management/$clubid/add-host')({
  component: RouteComponent,
  loader: () => {
    return {
      crumb: <CrumbTitle title="Manage Host" id="storeManagement.hostManagement.manageHost.crumb" icon={UserPenIcon} />,
      title: <Translation id="storeManagement.hostManagement.manageHost.page.title" />,
    };
  },
});

function RouteComponent() {
  return <Outlet />;
}
